import "./styles.scss";
import React, { useState, useEffect } from "react";
import { Card, CardImg, CardBody, CardText, Badge, Spinner } from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import whatsapp from "assets/images/whatsapp.png";
import AuthCard from "./AuthCard";
import CallModal from "./CallModal";
import ProfileService from "services/Website/ProfileService";
import { toast } from "react-toastify";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import {
	authenticate,
	addInterestResale,
	addInterest,
} from "store/Auth/actions";
import bedImg from "assets/images/bedroom.png";
import bathImg from "assets/images/bath.png";
import distanceImg from "assets/images/distance.png";
import InterestServices from "services/Website/InterestServices";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";
import MessageModal from "./MessageModal";
import ReactWhatsapp from "react-whatsapp";

const ResaleCard = ({
	resale,
	history,
	profile,
	updateProfileInterest,
	location,
}) => {
	const { t } = useTranslation();
	const [modal, setModal] = useState(false);
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [Interested, setInterested] = useState(false);
	const interestServices = new InterestServices();
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const dispatch = useDispatch();
	const [toggleInterest, setToggleInterest] = useState(false);
	const [interestLoading, setInterestLoading] = useState(false);
	const [hovered, setHovered] = useState(false);

	const interestHandler = (id) => {
		const data = { resale_id: id };
		setInterestLoading(true);
		if (AuthData.token && AuthData.userType === "user") {
			if (!isInterested()) {
				interestServices.createInterest(data).then((response) => {
					if (response && response.status === SuccessCreated) {
						toast.success(`${"Resale Added to Your Interests Successfully"}`);
						dispatch(
							addInterest({
								interestsResales: [...AuthData.interestsResales, id],
							})
						);
						setInterestLoading(false);
					}
				});
			} else {
				interestServices.deleteInterest(data).then((response) => {
					if (response && response.status === SuccessOk) {
						toast.success(`${t("Resale removed from Your interests")}`);
						const updatedInteres = AuthData.interestsResales.filter(
							(item) => item !== resale.id
						);
						dispatch(addInterest({ interestsResales: [...updatedInteres] }));
						setInterestLoading(false);
					}
				});
			}
		} else {
			dispatch(authenticate({ navigateTo: `/resale-view/${id}` }));
			history.push(`/login`, {
				navigateTo: `/resale-view/${id}`,
			});
		}
	};

	useEffect(() => {
		const id = parseInt(resale?.id);
		setInterested(AuthData.interestsResales.includes(id));
	}, [AuthData.interestsResales]);

	const isInterested = () => {
		const id = parseInt(resale?.id);
		return AuthData.interestsResales.includes(id);
	};

	// const interestHandler = (id) => {
	// 	setToggleInterest(true);
	// 	const data = { resale_id: id };
	// 	if (!isInterested()) {
	// 		dispatch(addInterestResale(id, data, "add", setToggleInterest));
	// 		//   setToggleInterest(false)
	// 	} else {
	// 		dispatch(
	// 			addInterestResale(
	// 				id,
	// 				data,
	// 				"delete",
	// 				setToggleInterest,
	// 				updateProfileInterest,
	// 				profile
	// 			)
	// 		);
	// 		// setToggleInterest(false)

	// 		// if (profile) {
	// 		//     updateProfileInterest()
	// 		// }
	// 	}
	// };
	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			history.push(`/resale-view/${resale?.id}`);
		} else {
			dispatch(authenticate({ navigateTo: `/resale-view/${resale?.id}` }));
			history.push(`/login`, { navigateTo: `/resale-view/${resale?.id}` });
		}
	};

	return (
		<React.Fragment>
			<div className="websitPages" onClick={() => checkAuth()}>
				<div>
					<Card className="comCard">
						{resale?.images?.length > 0 ? (
							resale?.images?.map((img, index) => {
								if (index === 0) {
									return <CardImg key={index} src={img.path}></CardImg>;
								}
							})
						) : (
							<CardImg src={compoundImg}></CardImg>
						)}
						<CardBody>
							{interestLoading ? (
								<div className="bgheartResale">
									<Spinner size="sm" color="primary" />
								</div>
							) : (
								<div>
									{isInterested() ? (
										<i
											className="fas fa-heart bgheartResale"
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												interestHandler(resale?.id);
											}}></i>
									) : (
										<i
											onMouseEnter={() => setHovered(true)}
											onMouseLeave={() => setHovered(false)}
											className={`${
												hovered ? "fas" : "far"
											} fa-heart bgheartResale`}
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												interestHandler(resale?.id);
											}}></i>
									)}
								</div>
							)}
							{Number(resale?.views) > 0 && (
								<span className="bgviewResale">
									<i className=" fa fa-eye" />
									<span>{resale?.views}</span>
								</span>
							)}
							<div className="maxBodyHeight">
								<CardText
									tag="h4"
									className="text-card font-size-24 mb-0 pb-1 fw-bold">
									{resale?.name[`${AuthData?.lang}`]
										? resale?.name[`${AuthData?.lang}`]
										: resale?.name?.en}
									<span className="font-size-12 float-end">
										{resale?.unit_type?.name[AuthData?.lang]}
									</span>
								</CardText>
								<CardText
									tag="p"
									className="text-card h-42 fw-medium font-size-14 com-description">
									{resale?.location?.street_address[AuthData?.lang]
										? resale?.location?.street_address[AuthData?.lang]
										: resale?.location?.street_address?.en}{" "}
									,
									{resale?.location?.City[AuthData?.lang]
										? resale?.location?.City[AuthData?.lang]
										: resale?.location?.City?.en}{" "}
									,
									{resale?.location?.governorate[AuthData?.lang]
										? resale?.location?.governorate[AuthData?.lang]
										: resale?.location?.governorate?.en}
								</CardText>

								<div className="d-flex justify-content-between roomsBeds border-bottom">
									<p className="d-flex gap-md-2 gap-1 mb-0">
										{!!resale?.bedrooms && (
											<>
												<img src={bedImg} width="16px" height="16px" alt="" />
												<span className="text-card font-size-12">
													{resale?.bedrooms} {t("rooms")}
												</span>
											</>
										)}
									</p>
									<p className="d-flex gap-md-2 gap-1 mb-0">
										{!!resale?.bathrooms && (
											<>
												<img src={bathImg} width="16px" height="16px" alt="" />
												<span className="text-card font-size-12">
													{" "}
													{resale?.bathrooms} {t("Bathrooms")}
												</span>
											</>
										)}
									</p>
									<p className="d-flex gap-md-2 gap-1 mb-0">
										{!!resale?.total_built_up_area && (
											<>
												<img
													src={distanceImg}
													width="16px"
													height="16px"
													alt=""
												/>
												<span className="text-card font-size-12">
													{parseInt(resale?.total_built_up_area).toFixed(0)} m{" "}
													<sup>2</sup>
												</span>
											</>
										)}
									</p>
								</div>
								<hr />
								<CardText tag="h6" className="font-size-14 text-card">
									{t("Deposit")} {toCurrency(resale?.payment_plan?.depost)}{" "}
									{currency?.currency_code}
								</CardText>
								<CardText
									tag="h3"
									className="pb-2 fw-bolder text-card font-size-24 pb-3">
									<span>
										{toCurrency(resale?.payment_plan?.total_price)}{" "}
										{currency?.currency_code}
									</span>
								</CardText>
								{/* <CardText tag="h4" className="my-1 d-flex justify-content-between align-items-center"> */}
								{/* <span className="font-size-16">{toCurrency(resale?.payment_plan?.total_price)} {currency?.currency_code}</span> */}
								{/* <Badge
                                        className="bg-primary p-2  font-size-12"
                                    >
                                        {resale?.finishing_type?.name[`${AuthData?.lang}`] ? resale?.finishing_type?.name[`${AuthData?.lang}`] : resale?.finishing_type?.name?.en}
                                    </Badge> */}
								{/* </CardText> */}
							</div>
							<div className="d-flex">
								<div className=" w-100">
									<button
										className="w-100 btn btnMoreInfo text-center"
										onClick={(e) => {
											e.stopPropagation();
											if (AuthData.token && AuthData.userType === "user") {
												setCallModal((c) => !c);
											} else {
												setModal(true);
											}
										}}>
										{t("More Information")}
									</button>
								</div>
								{/* <div className="mx-2 w-100" >
                                    <button className="w-100 btn btnMessage  text-center"   onClick={(e) => {
                                        e.stopPropagation()
                                        if (AuthData.token && AuthData.userType === "user") {
                                            setMessageModal(c => !c)
                                        } else {
                                            setModal(true)
                                        }
                                    }}  >
                                        <i className="fa fa-envelope"></i>
                                    </button>
                                </div>
                                {toggleInterest ? <div className="w-100 d-flex justify-content-center pt-2">
                                    <Spinner size="sm" color="primary" />
                                </div> : <div className="w-100 "
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        if ((AuthData.token && AuthData.userType === "user")) {
                                            interestHandler(resale ?.id)
                                        } else {
                                            setModal(true)
                                        }
                                    }}
                                >
                                        <button className="w-100 btn btnMessage text-center">
                                            {Interested ? <i className="fas fa-heart text-danger"></i> :
                                                <i className="far fa-heart text-danger"></i>}
                                        </button>
                                </div>}
                                <div className="mx-2 w-100" >
                                    <ReactWhatsapp number={resale?.sales_rep?.phone?.includes('+') ? resale?.sales_rep?.phone : `+2${resale?.sales_rep?.phone}`} class='btn btnMessage w-100' message="">
                                        <img src={whatsapp} alt='whatsapp' width='20' />
                                    </ReactWhatsapp>
                                </div> */}
							</div>
						</CardBody>
					</Card>
				</div>
			</div>

			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={resale}
					type="resale"
				/>
			)}
			{/* <AuthCard modal={modal} setModal={setModal} history={history} location={location} /> */}
			<CallModal
				modal={callModal}
				setModal={setCallModal}
				phone={resale?.sales_rep?.phone}
			/>
			<MessageModal
				modal={messageModal}
				setModal={setMessageModal}
				item={resale}
				type="resale"
			/>
		</React.Fragment>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default ResaleCard;
